// DashboardPanel/index.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import EventsDashboardBlade from './EventsDashboardBlade';
import TrainingDashboardBlade from './TrainingDashboardBlade';
import AccidentsDashboardBlade from './AccidentsDashboardBlade';
import HazardDashboardBlade from './HazardDashboardBlade';

const useStyles = makeStyles((theme) => ({
  bladesContainer: {
    display: 'flex'
  },
  blade: {},
  columnOne: {
    width: '50%'
  },
  columnTwo: {
    width: '50%'
  }
}));

function DashboardPanel(props) {
  const classes = useStyles();

  const {
    branchId,
    fetchAllEventsForBranch,
    events,
    setCurrentBranchesRecord,
    handleEventRecordEditClick,
    fetchAllCourseRecordssForBranch,
    fetchAllCoursesForBranch,
    fetchAllAccidentsForBranch,
    courses,
    accidents,
    handleCourseRecordEditClick,
    courseRecords,
    fetchAllHazardsForBranch,
    hazards,
    handleHazardItemEditClick,
    fetchAllPersonnels
  } = props;

  return (
    <React.Fragment>
      <div className={classes.bladesContainer}>
        <div className={classes.columnOne}>
          <div className={classes.blade}>
            <EventsDashboardBlade
              branchId={branchId}
              fetchAllEventsForBranch={fetchAllEventsForBranch}
              allEvents={events}
              setCurrentBranchesRecord={setCurrentBranchesRecord}
              handleEventRecordEditClick={handleEventRecordEditClick}
            />
          </div>
          <div className={classes.blade}>
            <AccidentsDashboardBlade
              allAccidents={accidents}
              branchId={branchId}
              setCurrentBranchesRecord={setCurrentBranchesRecord}
              fetchAllAccidentsForBranch={fetchAllAccidentsForBranch}
            />
          </div>
        </div>
        <div className={classes.columnTwo}>
          <div className={classes.blade}>
            <TrainingDashboardBlade
              branchId={branchId}
              fetchAllCourseRecordssForBranch={fetchAllCourseRecordssForBranch}
              fetchAllCoursesForBranch={fetchAllCoursesForBranch}
              allCourses={courses}
              setCurrentBranchesRecord={setCurrentBranchesRecord}
              handleCourseRecordEditClick={handleCourseRecordEditClick}
              courseRecords={courseRecords}
              fetchAllPersonnels = {fetchAllPersonnels}
            />
          </div>

          <div className={classes.blade}>
            <HazardDashboardBlade
              branchId={branchId}
              fetchAllHazardsForBranch={fetchAllHazardsForBranch}
              allHazards={hazards}
              setCurrentBranchesRecord={setCurrentBranchesRecord}
              handleHazardItemEditClick={handleHazardItemEditClick}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default DashboardPanel;
